var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spinner",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registration---ICBC---Short---with-spinner",
    transform: "translate(-491.000000, -390.000000)",
    strokeWidth: 3.81818182
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4",
    transform: "translate(491.000000, 390.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#CEF0F7",
    cx: 21.2937063,
    cy: 21.2937063,
    r: 19.3846154
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2937063,1.90909091 C10.5878788,1.90909091 1.90909091,10.5878788 1.90909091,21.2937063 C1.90909091,31.9995338 10.5878788,40.6783217 21.2937063,40.6783217 L21.2937063,40.6783217 C31.9995338,40.6783217 40.6783217,31.9995338 40.6783217,21.2937063",
    id: "Path",
    stroke: "#00BCE2",
    strokeLinecap: "round",
    transform: "translate(21.293706, 21.293706) rotate(-88.000000) translate(-21.293706, -21.293706) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.e7ee07b54b5c9c136856728f9379dc01.svg";
export { ForwardRef as ReactComponent };